import { render, staticRenderFns } from "./EditableCellTags.vue?vue&type=template&id=28328b50"
import script from "./EditableCellTags.vue?vue&type=script&lang=ts"
export * from "./EditableCellTags.vue?vue&type=script&lang=ts"
import style0 from "./EditableCellTags.vue?vue&type=style&index=0&id=28328b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports